import { formatUploadFileSize, readFileAsDataUrl } from './file-upload-utils'

export const RASPADINHA_IMAGE_ACCEPT = 'image/png,image/jpeg,image/jpg,image/webp,image/gif'

const ALLOWED_IMAGE_MIME_TYPES = new Set([
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
])

export const RASPADINHA_MAX_IMAGE_BYTES = 5 * 1024 * 1024

export function validateRaspadinhaImageFile(
  file: File,
  label: string,
  maxBytes = RASPADINHA_MAX_IMAGE_BYTES
): string | null {
  if (!ALLOWED_IMAGE_MIME_TYPES.has(file.type)) {
    return `${label} deve ser PNG, JPG, WEBP ou GIF.`
  }
  if (file.size > maxBytes) {
    return `${label} excede o limite de ${formatUploadFileSize(maxBytes)}. Arquivo selecionado: ${formatUploadFileSize(file.size)}.`
  }
  return null
}

export function readImageFileAsDataUrl(file: File): Promise<string> {
  return readFileAsDataUrl(file)
}
